import {catchError, map, of, switchMap} from 'rxjs';

import {inject, Injectable} from '@angular/core';
import {IFormGroup} from '@core/api/data-access';
import {Actions, createEffect, ofType} from '@ngrx/effects';

import {CyclesService} from '../../services';
import {formGroupActions} from './form-group.actions';

@Injectable()
export class FormGroupEffects {
	private actions$ = inject(Actions);
	private readonly cyclesService: CyclesService = inject(CyclesService);

	constructor() {}

	getFormGroupList$ = createEffect(() => {
		return this.actions$.pipe(
			ofType(formGroupActions.getFormGroupsList),
			switchMap(() => {
				return this.cyclesService.Forms.getFormGroup().pipe(
					map((formGroups: IFormGroup[]) => {
						return formGroupActions.getFormGroupsListSuccess({formGroups});
					}),
					catchError(error => {
						return of(formGroupActions.getFormGroupsListFailure({error}));
					}),
				);
			}),
		);
	});
}
